import { SVGProps } from 'react'

import { wrapIllustration } from '../wrap-illustration'

function SvgDocTwistTemplate(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={160}
      height={160}
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M103.044 88.532c6.575-1.31 10.849-7.7 9.538-14.276l-59.543 11.82c1.31 6.576-2.964 12.965-9.55 14.275l59.544-11.82h.011Z"
        fill="#E2E8F0"
      />
      <path
        d="M76.948 19.449c6.576-1.31 12.965 2.963 14.275 9.549 2.368 11.907-4.813 38.088-2.455 49.995 1.31 6.575 7.7 10.849 14.275 9.549l-59.544 11.82c-6.575 1.3-12.965-2.964-14.274-9.55-2.369-11.906 4.812-38.088 2.454-49.994-1.31-6.575-7.7-10.85-14.274-9.549l59.543-11.82Z"
        fill="#F1F5F9"
      />
      <path
        d="M88.612 78.208a.8.8 0 0 1 .94.628c1.225 6.142 7.194 10.135 13.336 8.92a.8.8 0 0 1 .31 1.57c-7.008 1.387-13.817-3.169-15.214-10.177a.8.8 0 0 1 .628-.94Z"
        fill="#0F172A"
      />
      <path
        d="M88.451 23.36a12.147 12.147 0 0 0-11.493-3.91L17.415 31.27c6.575-1.31 12.965 2.963 14.274 9.549.35 1.756.489 3.814.48 6.094l42.377-8.41c-1.31-6.575 2.964-12.964 9.55-14.274l4.366-.868h-.01Z"
        fill="#E2E8F0"
      />
      <path
        d="M17.415 31.27c-6.575 1.3-10.849 7.69-9.55 14.274l59.544-11.82C66.1 27.15 70.373 20.76 76.96 19.45L17.414 31.27Z"
        fill="#F1F5F9"
      />
      <path
        d="M76.792 18.665a.8.8 0 0 1 .313 1.568c-6.153 1.224-10.145 7.193-8.921 13.334a.8.8 0 0 1-.629.941l-22.621 4.49a.8.8 0 1 1-.312-1.568l21.86-4.341c-.917-6.724 3.557-13.081 10.31-14.424Z"
        fill="#0F172A"
      />
      <path d="m80.881 49.608-23.995 4.724.598-6.318 23.814-4.726-.417 6.32Z" fill="#A6DBCB" />
      <path
        d="M79.117 61.522a.8.8 0 1 1 .312 1.57L37.75 71.364a.8.8 0 1 1-.311-1.57l41.678-8.273ZM78.506 74.024a.8.8 0 1 1 .312 1.569l-23.506 4.666a.8.8 0 0 1-.311-1.57l23.505-4.665ZM80.311 55.102a.8.8 0 1 1 .312 1.569l-41.679 8.273a.8.8 0 1 1-.311-1.569l41.678-8.273ZM79.104 67.716a.8.8 0 1 1 .312 1.57L55.099 74.11a.8.8 0 0 1-.311-1.569l24.316-4.825ZM78.81 79.728a.8.8 0 0 1 .312 1.569l-23.875 4.742a.8.8 0 1 1-.312-1.569l23.876-4.742Z"
        fill="#B3C0D0"
      />
      <path
        d="M45.126 57.845a.913.913 0 0 0 .94-.1c1.14-.857 4.093-3.35 3.77-6.3-.258-2.38-3.261-3.268-4.616-1.015l-.354.595-.474-.508c-1.8-1.913-4.546-.4-4.287 1.979.323 2.951 3.731 4.768 5.031 5.35h-.01Z"
        fill="#78B441"
      />
      <path
        d="M44.727 49.728c.872-1.204 2.206-1.604 3.406-1.304 1.268.316 2.332 1.4 2.5 2.933.192 1.77-.6 3.336-1.497 4.51-.9 1.177-1.986 2.062-2.584 2.511v.001a1.713 1.713 0 0 1-1.755.196l-.036-.021c-.694-.315-1.916-.943-3.025-1.885-1.126-.956-2.233-2.319-2.426-4.086-.167-1.534.64-2.822 1.811-3.403 1.109-.55 2.497-.444 3.605.548Zm3.019.248c-.613-.153-1.346.042-1.841.866l-.351.591a.8.8 0 0 1-1.273.138l-.47-.505-.126-.124c-.626-.578-1.322-.591-1.852-.328-.588.291-1.024.95-.933 1.795.13 1.183.888 2.205 1.872 3.04.974.828 2.077 1.392 2.692 1.668l.011.005c.022.007.04.01.054.009a.094.094 0 0 0 .049-.02l.007-.005c.545-.41 1.503-1.197 2.28-2.212.783-1.025 1.306-2.181 1.177-3.363-.093-.847-.659-1.396-1.296-1.555Z"
        fill="#78B441"
      />
      <path
        d="M37.567 89.153c-1.607-7.163.015-12.379.015-12.379l12.245-2.427s-.473 6.407.303 12.318l-12.564 2.498v-.01Z"
        fill="#A6DBCB"
      />
    </svg>
  )
}
export default wrapIllustration(SvgDocTwistTemplate)
